import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppGuardGuard } from './../../guards/app-guard.guard';

import { BasicInputsComponent } from './basic-inputs/basic-inputs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { EditorComponent } from './editor/editor.component';
import { FormLayoutsComponent } from './form-layouts/form-layouts.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { MasksComponent } from './masks/masks.component';
import { DevicesComponent } from './master/devices/devices.component';
import { ToiletComponent } from './master/toilet/toilet.component';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { ValidationComponent } from './validation/validation.component';
import { InstallDeviceReportComponent } from './report/install-device-report/install-device-report.component';
import { ActiveDeviceReportComponent } from './report/active-device-report/active-device-report.component';
import { InactiveDeviceReportComponent } from './report/inactive-device-report/inactive-device-report.component';
//import { AirQualityReportComponent } from '../../app/form/report/air-quality-report/air-quality-report';
import { AirQualityReportComponent } from './report/air-quality-report/air-quality-report';
import { UserFeedbackReportComponent } from './report/user-feedback-report/user-feedback-report.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { HelpComponent } from './help/help.component';
import { ToiletReportComponent } from './report/toilet-report/toilet-report.component';
import { AirQualityDetailReportComponent } from './report/air-quality-detail-report/air-quality-detail-report.component';
import { UserFeedbackDetailReportComponent } from './report/user-feedback-detail-report/user-feedback-detail-report.component';
import { WaterLavelReportComponent } from './report/water-lavel-report/water-lavel-report.component';
import { DeviceLocationComponent } from './device-location/device-location.component';
import { DeviceLogComponent } from './report/device-log/device-log.component';
import { UsersComponent } from './master/users/users.component';
import { ToiletDashboardComponent } from './toilet-dashboard/toilet-dashboard.component';
import { ToiletStatusReportComponent } from './report/toilet-status-report/toilet-status-report.component';
import { OfficerMasterComponent } from './master/officer-master/officer-master.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'officer-master',
        component: OfficerMasterComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Officer Master'
        }
      },
      {
        path: 'toilet-status-report',
        component: ToiletStatusReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Toilet Status Report'
        }
      },
      {
        path: 'toilet-dashboard',
        component: ToiletDashboardComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Toilet Dashboard'
        }
      },
      {
        path: 'users',
        component: UsersComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Users'
        }
      },
      {
        path: 'device-log',
        component: DeviceLogComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Device Log'
        }
      },
      {
        path: 'device-location',
        component: DeviceLocationComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Device Location'
        }
      },
      {
        path: 'water-lavel-report',
        component: WaterLavelReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Water Lavel Report'
        }
      },
      {
        path: 'air-quality-detail-report',
        component: AirQualityDetailReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Air Quality Detail Report'
        }
      },
      {
        path: 'user-feedback-detail-report',
        component: UserFeedbackDetailReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'User Feedback Detail Report'
        }
      },
      {
        path: 'toilet-report',
        component: ToiletReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Toilet Report'
        }
      },
      {
        path: 'about-us',
        component: AboutUsComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: ' About Us'
        }
      },
      {
        path: 'help',
        component:HelpComponent,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Help'
        }
      },
      {
        path: 'inactive-device-report',
        component:InactiveDeviceReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Inactiv Device Report'
        }
      },
      {
        path: 'active-device-report',
        component:ActiveDeviceReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Active Device Report'
        }
      },
      {
        path: 'air-quality-report',
        component:AirQualityReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Air Quality Report'
        }
      },
      {
        path: 'user-feedback-report',
        component:UserFeedbackReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'User Feedback Report'
        }
      },
      {
        path: 'install-device-report',
        component:InstallDeviceReportComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'Install Device Report'
        }
      },
      {
        path: 'toilet',
        component:ToiletComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'toilet'
        }
      }, 
      {
        path: 'devices',
        component:DevicesComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'devices'
        }
      }, 
      {
        path: 'dashboard',
        component:DashboardComponent ,
        canActivate: [AppGuardGuard],
        data: {
          heading: 'dashboard'
        }
      }, 
      
      {
        path: 'basic-inputs',
        component: BasicInputsComponent,
        data: {
          heading: 'Basic forms'
        }
      }, 
      {
        path: 'input-group',
        component: InputGroupComponent,
        data: {
          heading: 'Input Group'
        }
      }, 
      
      {
        path: 'form-layouts',
        component: FormLayoutsComponent,
        data: {
          heading: 'Form Layouts'
        }
      }, 
    {
      path: 'masks',
      component: MasksComponent,
      data: {
        heading: 'Masks'
      }
    }, 
    {
      path: 'editor',
      component: EditorComponent,
      data: {
        heading: 'Editor'
      }
    },
    {
      path: 'validation',
      component: ValidationComponent,
      data: {
        heading: 'Validation'
      }
    },
    {
      path: 'timepicker',
      component: TimepickerComponent,
      data: {
        heading: 'Timepicker'
      }
    },
    {
      path: 'datepicker',
      component: DatepickerComponent,
      data: {
        heading: 'Datepicker'
      }
    },
   ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FormRoutingModule { }
